module.exports = __webpack_public_path__ + "img/gradient-9.732f518c.png";